import slice from "./post-editing.slice";

const { setEditingPost } = slice.actions;

export { setEditingPost };
